import { useContext } from "react";

import { FileRecordDetailsStateContext } from "./FileRecordDetailsStateContext";

export const useFileRecordDetailsState = (): FileRecordDetailsStateContext => {
    return useContext(FileRecordDetailsStateContext);
};
